import React from 'react';
import { IAgilePointConfiguration } from '@agilepoint/wat';
import { useConfigScopeSelectors } from 'modules/core/scopes';

class ServiceClient {
    private restURL: string | undefined;
    private headers = new Headers();

    constructor(apConfig: IAgilePointConfiguration) {
        this.restURL = apConfig.apiUrl;
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Authorization', apConfig.auth);
    }

    private fetchData = (endPoint: string, init?: Pick<RequestInit, 'body' | 'method'>, headers?: HeadersInit) => fetch(`${this.restURL}${endPoint}`, {
        headers: this.headers,
        body: init?.body,
        method: init?.method
    }).then((res) => {
        if (res.status === 200) {
            return res;
        }
        throw new Error(`Something went wrong! Status Code: ${res.status} Message: ${res.statusText}`);
    }).catch((err) => {
        throw new Error(err);
    });

    public getData = (endPoint: string, headers?: HeadersInit) => this.fetchData(endPoint, { method: 'GET' }, headers)

    public postData = (endPoint: string, body?: Object, headers?: HeadersInit) => this.fetchData(endPoint, {
        method: 'POST',
        body: JSON.stringify(body)
    },
        headers)
}

const arg: Pick<ServiceClient, 'getData' | 'postData'> = {
    getData: (endPoint: string, headers?: HeadersInit) => new Promise((res) => res),
    postData: (endPoint: string, body?: Object, headers?: HeadersInit) => new Promise((res) => res)
};

const ServiceClientContext = React.createContext(arg);

export const ServiceClientProvider = React.memo((props: { children: React.ReactNode }) => {
    const { selectAgilePointConfig } = useConfigScopeSelectors();
    const apConfig = selectAgilePointConfig();

    return (
        <ServiceClientContext.Provider value={new ServiceClient(apConfig)}>
            {props.children}
        </ServiceClientContext.Provider>
    );
});

export const useServiceClient = () => React.useContext(ServiceClientContext);


